import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { ModalService } from '../../../core/services/modal.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-batch-del-control',
  templateUrl: './batch-del-control.component.html',
  styleUrls: ['./batch-del-control.component.css']
})
export class BatchDelControlComponent implements OnInit {
    batchDeliveryKeyno;

    purchInternalNo;

    public selectedBgBatchDelControl: string = 'COLLI';

    public setting?: Setting;

    public itemsListControls: Item[] = [];

    public itemsListSkus: Item[] = [];

    public approving = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.batchDeliveryKeyno = this.stateService.getStateParams()['batchdelivery_keyno'];
        this.purchInternalNo = this.stateService.getStateParams()['purch_internal_no'];
    }

    private async loadSetting() {
        if (!!this.batchDeliveryKeyno && !!this.purchInternalNo) {
            this.setting = (await this.datatask.Post(1645, {
                batchdelivery_keyno: this.batchDeliveryKeyno,
                purch_internal_no: this.purchInternalNo
            }))[0];
        }
    }

    private async loadControls() {
        if (!this.setting) return;

        return this.itemsListControls = await this.datatask.Post(1603, this.setting);
    }

    private async loadSkus() {
        if (!this.setting) return;

        return this.itemsListSkus = await this.datatask.Post(1647, this.setting);
    }

    public async approveChanges() {
        if (!!this.setting) {
            try {
                this.approving = true;

                const response = (await this.datatask.Post(1646, this.setting))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.go('batchdelivery', { batchdelivery_keyno: this.setting.batchdelivery_keyno });
                }
            } finally {
                this.approving = false;
            }
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadControls();
        this.loadSkus();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    batchdelivery_keyno: string;
    searchtext: string;
    purch_internal_no: string;
    nbr_of_deviations: string;
}
